import { render, staticRenderFns } from "./awardRecord.vue?vue&type=template&id=22148ce4&scoped=true"
import script from "./awardRecord.vue?vue&type=script&lang=js"
export * from "./awardRecord.vue?vue&type=script&lang=js"
import style0 from "./awardRecord.vue?vue&type=style&index=0&id=22148ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22148ce4",
  null
  
)

export default component.exports